"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const NavbarStyled = styled_components_1.default.div `
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 60px;
    border-bottom: 3px solid #ccc;
    margin-bottom: 10px;

    ul {
        display: flex;
        flex-direction: row;
        align-items: center;
        list-style-type: none;
        margin: 0 2px;
        width: 95vw;
    }

    li {
        /* display: inline; */
    }

    .container {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .brand {
        z-index: 1;
        position: absolute;
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .right-option {
        z-index: 2;
        position: absolute;
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }

    .brand-logo {
        height: 30px;
        width: auto;
    }

    @media (max-width: 768px) {
        .brand-logo {
            height: 20px;
        }

        .brand {
            display: flex;
            justify-content: flex-start;
        }
    }
`;
const Navbar = ({ customStyle, children }) => {
    return (react_1.default.createElement(NavbarStyled, { style: customStyle }, children));
};
exports.Navbar = Navbar;
